import React from 'react';

const AboutSection = () => {
  return (
    <section id="about" className="py-24 bg-gray-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Text Content */}
          <div className="space-y-6">
            <h2 className="text-4xl md:text-5xl font-bold text-white leading-tight">
              Built on Reliability.
              <br />
              <span className="text-amber-500">Driven by Experience.</span>
            </h2>
            <div className="space-y-4 text-gray-300 text-lg leading-relaxed">
              <p>
                H.A.R.P Solutions LTD was founded by Tobe Harrington with a clear vision: 
                to deliver seamless, responsive, and high-quality engineering services without 
                the usual delays or complications.
              </p>
              <p>
                Recognising the need for a more reliable all-in-one solution, he built a company 
                that brings together Handyman, Air Conditioning, Refrigeration, and Plumbing under 
                one trusted name.
              </p>
              <p>
                Today, we support everything from homes to commercial units, supermarkets, and 
                independent off-licences, delivering efficient solutions that keep properties 
                running safely and without disruption.
              </p>
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-br from-amber-600/20 to-amber-800/10 rounded-2xl transform rotate-3"></div>
            <img
              src="https://images.unsplash.com/photo-1621905251918-48416bd8575a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwzfHx0ZWNobmljaWFufGVufDB8fHx8MTc3NTc4MDYyM3ww&ixlib=rb-4.1.0&q=85"
              alt="Professional Technician"
              className="relative rounded-2xl shadow-2xl w-full h-[500px] object-cover border border-gray-800"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
